class tcPackagesModule extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                wrapperSelector: '.tc-packages-module',
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $wrapperSelector: this.$element.find(selectors.wrapperSelector),
        };
    }

    onInit(...args) {
        super.onInit(...args);
        console.log("[CAH] Packages module initialized");

        let broadCastData = (source) => {
            let data = {
                id: $wrapper.closest(".elementor-element").attr("data-id"),
                source: source,
                content: {
                    "Kubernetes": getSelectedValue(),
                },
            }

            $(document).trigger('tc-server-event', data);
        }

        let $wrapper = this.elements.$wrapperSelector;
        let $radio = $wrapper.find("input[type=radio]");

        let getSelectedValue = () => {
            let $selectedradio = $radio.clone().filter(":checked");
            return $selectedradio.val();
        }

        let handleRadioChange = (isSynthetic) => {
            let $selectedradio = $radio.clone().filter(":checked");
            let selectedValue = $selectedradio.val();
            broadCastData(isSynthetic ? "init" : "radio");
        }

        $radio.first().prop('checked', true);
        handleRadioChange(true);

        $radio.on("change", function(e, isSynthetic) {
            handleRadioChange(isSynthetic)
        })

        broadCastData("init");
    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(tcPackagesModule, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction('frontend/element_ready/tc-packages-module.default', addHandler);
});

